// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","fade-in":"Modal_fade-in__Xt+-i","closingCross":"Modal_closingCross__rjLZs"};